import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
// Redux
import { connect } from "react-redux";
import Loader from "../../Loader/Loader";
import s from "./ListFaq.css";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import messages from "../../../locale/messages";

import { PanelGroup, Panel } from "react-bootstrap";
import imageOne from "../../../../public/SiteImages/warrow.png";
class ListFaq extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
        hostId: PropTypes.number.isRequired,
        listingId: PropTypes.number.isRequired,
      })
    ),
    loading: PropTypes.bool,
  };
  state = {
    activeKey: "0", // default open panel
  };
  handleSelect = (activeKey) => {
    console.log(activeKey, "activeKey");
    this.setState({ activeKey });
  };

  render() {
    const { data, loading } = this.props;
    const { activeKey } = this.state;

    if (loading) {
      return <Loader type={"text"} />;
    }

    console.log(activeKey, "activeKey in render");

    return (
      <>
        {data?.length > 0 && (
          <>
            <div className={cx(s.space1)}>
              <p className={s.sectionTitleText}>
                <FormattedMessage {...messages.faqList} />
                
              </p>
            </div>
            <PanelGroup
              accordion
              id="accordion"
              className={cx(s.faqAccordian)}
              activeKey={activeKey}
              onSelect={this.handleSelect}
            >
              {data?.map((item, index) => (
                <Panel
                  eventKey={String(index)}
                  key={index}
                  className={cx(
                    Number(activeKey) === index && activeKey !== null
                      ? s.faqPanelOpen
                      : s.faqPanelClose
                  )}
                >
                  <Panel.Heading
                    className={cx(
                      Number(activeKey) === index && activeKey !== null
                        ? s.faqHeaderOpen
                        : s.faqHeaderClose
                    )}
                  >
                    <Panel.Title toggle>
                      {item?.question || ""} <img src={imageOne}></img>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible className={cx(s.faqBodyBg)}>
                    {item?.answer || ""}
                  </Panel.Body>
                </Panel>
              ))}
            </PanelGroup>
            <div className={s.listingLine}></div>
          </>
        )}
      </>
    );
  }
}

const mapState = (state) => ({
  siteName: state.siteSettings.data.siteName,
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(ListFaq))
);
